import axios from "axios";

export default {
  namespaced: true,
  state: {
    purchasereceipts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    purchasereceiptsMessage: ''
  },
  mutations: {
    RECEIVED_PURCHASERECEIPTS(state, payload) {
      state.purchasereceipts = payload;
      state.isReceiving = false;
    },
    RECEIVED_PURCHASERECEIPT(state, payload) {
      let find = state.purchasereceipts.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { purchasereceipts: [payload, ...state.purchasereceipts] });
      }
      else {
        let index = state.purchasereceipts.findIndex(x => x._id === payload._id);
        state.purchasereceipts.splice(index, 1, payload);
      }
    },
    RECEIVING_PURCHASERECEIPTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_PURCHASERECEIPT(state) {
      state.isReceiving = true;
    },

    UPDATED_PURCHASERECEIPTS(state, payload) {
      console.log(state.purchasereceipts);
      console.log(payload);
      let index = state.purchasereceipts.findIndex(purchasereceipt => purchasereceipt._id === payload._id);
      state = Object.assign(state, {
        purchasereceipts: state.purchasereceipts.map((purchasereceipt, i) => {
          if (i === index) {
            return Object.assign({}, purchasereceipt, payload);
          }
          return purchasereceipt;
        }),
        isUpdating: false,
        purchasereceiptsMessage: 'PurchaseReceipts has been updating!',
      })
    },
    UPDATING_PURCHASERECEIPTS(state) {
      state.isUpdating = true;
    },
    DELETED_PURCHASERECEIPTS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.purchasereceipts.findIndex(purchasereceipt => purchasereceipt._id === payload._id);
      console.log(indexToDelete);
      let purchasereceipts = [...state.purchasereceipts];
      purchasereceipts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        purchasereceipts: [...purchasereceipts],
        isDeleting: false,
        idToDelete: null,
        purchasereceiptsMessage: 'PurchaseReceipt has been Deleted!',
      });
    },
    DELETING_PURCHASERECEIPTS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertPurchaseReceiptRequest({dispatch}, payload) {
      dispatch("receivingPurchaseReceipts");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/insert/purchasereceipt/' + payload.purchasereceipt.purchaseorderid;
      console.log(url);
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      console.log(payload)
      var post = {method: "post",url: url, headers: headers, data: payload};
      return axios(post)
      .then(response=> {dispatch("receivePurchaseReceipt", response.data);})
      .catch((error) => {this.alertmessage = error;});	
    },
    async insertPOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let id = payload.id;
        delete payload['id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/potransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    deletePurchaseReceiptRequest({dispatch}, payload) {
      dispatch("deletingPurchaseReceipt", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/purchasereceipt/' + payload._id;
      let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      axios({ method: "delete", url: url, headers: headers })
      .then(response=>{
        dispatch("deletePurchaseReceipt", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deletePOTransactionRequest({dispatch}, id) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/potransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    getPurchaseReceiptsRequest({dispatch}) {
      dispatch("receivingPurchaseReceipts");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/purchasereceipts';
      let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      axios({ method: "get", url: url, headers: headers })
      .then(response => {
        dispatch("receivePurchaseReceipts", response.data);
      })
    },
    async getPurchaseReceiptRequest({dispatch}, id) {
      dispatch("receivingPurchaseReceipt");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/purchasereceipt/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receivePurchaseReceipt", response.data);
      })
    },
    async findPurchaseReceiptsRequest({dispatch}, payload) {
      try{
        dispatch("receivingPurchaseReceipts");
        console.log(payload)
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/purchasereceipts';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receivePurchaseReceipts", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updatePurchaseReceiptRequest({dispatch}, payload) {
      dispatch("updatingPurchaseReceipt");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/purchasereceipt/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers,data: payload})
      .then((response)=> {
        dispatch("updatePurchaseReceipt", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },

    async updatePurchaseReceiptTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        var id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/update/prtransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "put", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    receivePurchaseReceipts({commit}, payload) {
      commit("RECEIVED_PURCHASERECEIPTS", payload)
    },
    receivePurchaseReceipt({commit}, payload) {
      commit("RECEIVED_PURCHASERECEIPT", payload)
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivingPurchaseReceipts({commit}) {
      commit("RECEIVING_PURCHASERECEIPTS")
    },

    receivingPurchaseReceipt({commit}) {
      commit("RECEIVING_PURCHASERECEIPTS")
    },
    updatePurchaseReceipt({commit}, payload) {
      commit("UPDATED_PURCHASERECEIPTS", payload)
    },
    updatingPurchaseReceipt({commit}) {
      commit("UPDATING_PURCHASERECEIPTS")
    },
    deletePurchaseReceipt({commit}, payload) {
      commit("DELETED_PURCHASERECEIPTS", payload)
    },
    deletingPurchaseReceipt({commit}, payload) {
      commit("DELETING_PURCHASERECEIPTS", payload)
    }
  },
};
